import Chip from "@mui/material/Chip";

const CustomChip = ({ label }) => (
  <>
    <Chip
      label={label}
      size="small"
      sx={{
        backgroundImage: "linear-gradient(to bottom, #ffe050, #ffc107)", // gradiente amarillo claro a oscuro
        color: "#20202a", // mejor contraste con fondo amarillo
        padding: "2px 8px",
        fontWeight: "bold",
        boxShadow: "inset 0 1px 0 rgba(255,255,255,0.5), 2px 2px 4px rgba(0,0,0,0.3)",
        textShadow: "1px 1px 1px rgba(255,255,255,0.3)", // brillo sutil al texto
      }}
    />
  </>
);

export default CustomChip;



